import { has } from 'lodash'

export interface StartEmailCertificationApiOutput {
  DateTimeNextRequestsAvailable: string
  Email: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isStartEmailCertificationOutput = (output: any): output is StartEmailCertificationApiOutput =>
  has(output, 'DateTimeNextRequestsAvailable') &&
  typeof output.DateTimeNextRequestsAvailable === 'string' &&
  has(output, 'Email')
